<div class="position-relative subdistrict-autocomplete">
  <input
    type="text"
    class="form-control"
    [class.form-control-sm]="size() === 'sm'"
    [id]="id()"
    [attr.name]="name()"
    [placeholder]="placeholder()"
    [disabled]="isDisabled"
    [(ngModel)]="searchText"
    [ngModelOptions]="standaloneOptions"
    (ngModelChange)="onInputChange()"
    (focus)="onFocus()"
    (blur)="handleBlur()"
    role="combobox"
    aria-autocomplete="list"
    [attr.aria-expanded]="open"
    [attr.aria-controls]="id() + '-options'"
    autocomplete="off">

  @if (open) {
    <div class="dropdown-menu show w-100 mt-1" [id]="id() + '-options'" role="listbox">
      @for (item of suggestions; track trackBySubdistrictId($index, item)) {
        <button
          type="button"
          class="dropdown-item"
          role="option"
          (mousedown)="selectSubdistrict(item)">
          <span class="fw-semibold">{{ item.subdistrictTitle }}</span>
          @if (formatOption(item)) {
            <span class="text-body-secondary"> — {{ formatOption(item) }}</span>
          }
        </button>
      }
    </div>
  }

  @if (loading) {
    <div class="small text-body-secondary mt-1" role="status">กำลังค้นหา...</div>
  }
</div>
